module.exports = __webpack_public_path__ + "static/media/eng_d_2006.6e60fdbd.mp4";